/**
 * Property label and key mapping
 */
import { l10n } from '../../../i18n/i18nUtil';

export const KEY_LABEL_MAP = {
  certificateChain: l10n('appConstants.fieldMapping.certificateChain'),
  period: l10n('appConstants.fieldMapping.period'),
  expiresOn: l10n('appConstants.fieldMapping.expiresOn'),
  issuedOn: l10n('appConstants.fieldMapping.issuedOn'),
  healthy: l10n( 'appConstants.fieldMapping.healthy'),
  subject: l10n('appConstants.fieldMapping.subject'),
  issuer: l10n( 'appConstants.fieldMapping.issuer'),
  san: l10n( 'appConstants.fieldMapping.san'),
  algorithm: l10n( 'appConstants.fieldMapping.algorithm'),
  keyAlgorithm: l10n( 'appConstants.fieldMapping.keyAlgorithm'),
  sha256: l10n( 'appConstants.fieldMapping.sha256'),
  sha1: l10n( 'appConstants.fieldMapping.sha1'),
  validity: l10n( 'appConstants.fieldMapping.validity'),
  certificateInfo: l10n( 'appConstants.fieldMapping.certificateInfo'),
  alias: l10n( 'appConstants.fieldMapping.alias'),
};

/**
 * Password keys
 */
export const PASSWORD_KEYS = ['defaultPassword', 'vcPassword'];

/**
 * Properties that shouldn't be displayed
 */
export const HIDDEN_KEYS = [
  ...PASSWORD_KEYS,
  'key',
  'certificateChain',
  'leafCertificate',
  'validations',
  'vmid',
  'healthy'
];
